import React from "react";

const SvgSmallCan = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M138 41.3h.3c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5H74.7c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5h.3l-8.3 12.4v112.6l6.6 13.7h66.4l6.6-13.7V53.6L138 41.3zm-57 0h51l4.9 7.3H76.2l4.8-7.3zm52.5 39.8v57.8h-54V81.1h54zm3 93.8h-60l-1.7-3.6h63.5l-1.8 3.6z"
      fill="currentColor"
    />
  </svg>
);

export default SvgSmallCan;